import { MenuService } from '@/layout/service/menu.service';
import { Component, OnInit } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

/**
 * Componente principal (layout) para o módulo de Arrecadação.
 * Responsável por renderizar as rotas filhas, gerenciar o menu lateral
 * e controlar a exibição do diálogo de pesquisa de pessoas.
 */
@Component({
    selector: 'app-orientacoes-relatorios-content',
    standalone: true,
    imports: [RouterModule],
    template: `
        <!-- No seu componente de layout principal -->
        <main class="w-full">
            <div>
                <router-outlet></router-outlet>
            </div>
        </main>
    `
})
export class OrientacoesTecnicasContent implements OnInit {
    /** Caminho base para as rotas do módulo. */
    rootPath = 'orientacoes';

    /** Estrutura do menu de navegação específico para o módulo de Arrecadação. */
    menu = [
        {
            label: 'Home',
            items: [
                {
                    label: 'Dashboard',
                    items: [{ label: 'Dados', icon: 'pi pi-fw pi-home', routerLink: [this.rootPath, 'dados-registro'] }]
                },
                { label: 'Relatorios', icon: 'pi pi-fw pi-file-import', routerLink: [this.rootPath + '/relatorios'] }
            ]
        }
    ];

    /**
     * Construtor para injetar serviços essenciais.
     * @param menuService - Serviço para gerenciar o estado do menu principal da aplicação.
     * @param router - Serviço do Angular para controle de navegação.
     */
    constructor(
        private menuService: MenuService,
        private router: Router
    ) {}

    /**
     * Hook do ciclo de vida. Executado na inicialização do componente.
     * Define o menu específico deste módulo no serviço de menu global.
     */
    ngOnInit(): void {
        this.menuService.setMenu(this.menu);
        this.menuService.setSistema('SICOM | Orientações Técnicas');
    }

    /**
     * Força o recarregamento do componente da rota especificada, mesmo que já esteja ativa.
     * Navega para uma rota temporária e depois retorna à original para forçar a reinicialização.
     * @param rota A rota de destino para recarregar.
     */
    private async executar(rota: string) {
        await this.router.navigateByUrl('/', { skipLocationChange: true });
        await this.router.navigate([rota]);
    }
}
